import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Loader from '../../Loader/Loader';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import { FaEdit, FaEye, FaTimes } from 'react-icons/fa';
import HttpClient from '../../utils/HttpClient';

const CareerBanner = () => {
    const bannerInit = {
        heading: "",
        subHeading: "",
        careerBaner: ""
    }
    const [careerBannerData, setCareerBannerData] = useState(bannerInit)
    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [bannerData, setBannerData] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [bannerID, setBannerId] = useState("");


    // >>>>Toggle Modal<<<<
    const toggleModal = () => setModalOpen(!modalOpen);

    // >>>>Handle View Details<<<<
    const handleViewDetails = () => {
        toggleModal();
    }

    // >>>>Handle Edit<<<<
    const handleEdit = () => {
        setBannerId(bannerData?._id)
        setIsEdit(true)
        setCareerBannerData({
            heading: bannerData.heading || '',
            subHeading: bannerData.subHeading || '',
            careerBaner: bannerData.careerBaner || ''
        });
        setImageFile(bannerData.careerBaner || null);
    };

    // >>>>Handle Banner Head Input Change<<<<
    const handleBannerHeadChange = (e) => {
        const { name, value } = e.target;
        setCareerBannerData({ ...careerBannerData, [name]: value });
    }

    // >>>>Handle Image<<<<
    const handleImage = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        // if (file.size > 5 * 1024 * 1024) {
        //     toast.error("Image size must be less than 5 MB");
        //     return;
        // }

        let formData = new FormData();
        formData.append("image", file);
        setLoading(true);
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res.status) {
            setLoading(false);
            toast.success("Image Uploaded Successfully");
            setImageFile(res?.url);
            setCareerBannerData({ ...careerBannerData, careerBaner: res?.url });
        } else {
            setLoading(false);
            setImageFile(null);
            toast.error(res?.message || "Something Went Wrong");
        }
    };

    // >>>>Handle Removing Image<<<<
    const handleRemoveImage = () => {
        setImageFile(null);
        setCareerBannerData({ ...careerBannerData, careerBaner: "" });
        document.getElementById("image").value = "";
    };

    // >>>>Fetch Career Banner Data<<<<
    const fetchCareerBannerData = async () => {
        setLoading(true);
        const res = await HttpClient.requestData("career", "GET");
        if (res && res?.status) {
            setLoading(false);
            setBannerData(res.data ? res.data : {});
        } else {
            setLoading(false);
            setBannerData({});
        }
    }

    // Handle Submit Data
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            heading: careerBannerData?.heading,
            subHeading: careerBannerData?.subHeading,
            careerBaner: careerBannerData?.careerBaner,
        };
        setLoading(true);
        const res = await HttpClient.requestData(`career/${bannerID}`, "PUT", data);
        if (res && res?.status) {
            setLoading(false);
            toast.success(res?.message || "Data updated successfully!");
            setCareerBannerData(bannerInit);
            fetchCareerBannerData()
            setImageFile(null);
            document.getElementById("image").value = "";
            setIsEdit(false)
        } else {
            setLoading(false);
            toast.error(res?.message || "Something went wrong...");
        }
    }

    useEffect(() => {
        fetchCareerBannerData();
    }, []);

    return (
        <div className="d-flex justify-content-end">
            {loading && <Loader />}
            <div className="form-header mx-2">
                <section className="piechartsBox_area">
                    {/* Career-Banner */}
                    {isEdit &&
                        <>
                            <div>
                                <h2>Update Career Banner</h2>
                                <form onSubmit={handleSubmit}>
                                    <div className='p-2' style={{ border: "1px solid #ccc", borderRadius: "10px" }}>
                                        <div className="form-row">
                                            <div className="form-group col-md-6 mb-3">
                                                <label htmlFor="heading">Heading</label>
                                                <input
                                                    type="text"
                                                    id="heading"
                                                    name="heading"
                                                    className="form-control"
                                                    value={careerBannerData?.heading}
                                                    onChange={handleBannerHeadChange}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mb-3">
                                                <label htmlFor="description">Sub-Heading</label>
                                                <textarea
                                                    id="description"
                                                    name="subHeading"
                                                    className="form-control"
                                                    rows="1"
                                                    value={careerBannerData?.subHeading}
                                                    onChange={handleBannerHeadChange}
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className='d-flex'>
                                            <div className="form-group mb-3 w-50">
                                                <label htmlFor="image">Career-Baner</label>
                                                <input
                                                    type="file"
                                                    id="image"
                                                    name="image"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleImage}
                                                />
                                            </div>
                                            {imageFile && (
                                                <div className="mx-5 d-flex align-items-center justify-content-center">
                                                    <img
                                                        className="mt-3"
                                                        alt="not found"
                                                        width={"100px"}
                                                        height={"100px"}
                                                        src={imageFile}
                                                        style={{ border: "1px solid #000", borderRadius: "10px", boxShadow: "0 10px 10px rgba(0,0,0,0.5)" }}
                                                    />
                                                    <span
                                                        style={{ marginTop: "-4rem", fontSize: "20px", cursor: "pointer" }}
                                                        onClick={() => handleRemoveImage()}
                                                    >
                                                        <i className="fa-solid fa-square-xmark" style={{ color: "#b40822" }}></i>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center mt-5'>
                                        <button type='submit' className='btn btn-outline-success w-50'>Update</button>
                                    </div>
                                </form>
                            </div>

                            <hr />
                        </>
                    }

                    {/* Custom Table to Display Banner Data */}
                    {bannerData && !isEdit && (
                        <div className="mt-5">
                            <h3>Career Banner Data</h3>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Heading</th>
                                        <th>Sub-Heading</th>
                                        <th>Career Banner</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{bannerData.heading || '-'}</td>
                                        <td>{bannerData.subHeading || '-'}</td>
                                        <td>
                                            {bannerData.careerBaner ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={bannerData.careerBaner}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>
                                            <FaEye
                                                style={{ cursor: "pointer", marginRight: "15px", color: "#007bff" }}
                                                onClick={handleViewDetails}
                                                title="View Details"
                                            />
                                            <FaEdit
                                                style={{ cursor: "pointer", color: "#28a745" }}
                                                onClick={handleEdit}
                                                title="Edit"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Modal for Viewing Details */}
                    <Modal isOpen={modalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Banner Details
                            <span style={{
                                marginLeft: "305px",
                                cursor: "pointer"
                            }} onClick={() => { toggleModal() }}><FaTimes className='' style={{ marginTop: "-20px" }} /></span>
                        </ModalHeader>
                        <ModalBody>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Heading</td>
                                        <td>{bannerData.heading || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Sub-Heading</td>
                                        <td>{bannerData.subHeading || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Career Banner</td>
                                        <td>
                                            {bannerData.careerBaner ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={bannerData.careerBaner}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ModalBody>
                        <Button color="secondary" onClick={toggleModal}>Close</Button>
                    </Modal>
                </section>
            </div>
        </div>
    )
}

export default CareerBanner